
import request from '@/utils/request'
class parent {
   
    login(data){
        return request({
            url:'/users/doLogin',
            method:'post',
            data:data
        })
    }
    // 获取账套信息/ztb/queryZtbByDm/{dm}
    getztxx(dm){
        return request({
            url:`/ztb/queryZtbByDm/${dm}`,
            method:'get'
        })
    }
    //获取认证码/oss/sendSms/{phone}
    getyzm(phone){
        return request({
            url:`/oss/sendSms/${phone}`,
            method:'get'
        })
    }
    ///oss/checkSmsAdmin/{phone}/{code}/{ztid}
    yzmdl(phone,code,ztid){
        return request({
            url:`/oss/checkSmsAdmin/${phone}/${code}/${ztid}`,
            method:'get'
        })
    }
  

}
let item = new parent()

export default item